import { Button, styled } from '@mui/material';
import { useState } from 'react';
import { useActiveBetaFeatures } from 'hooks/useFeatureFlag';
import BetaFeaturesDialog from './BetaFeaturesDialog';

const Launcher = styled(Button)`
  position: fixed;
  left: calc(${({ theme }) => theme.spacing(2)} + 26px);
  transform: translateX(-50%);
  bottom: ${({ theme }) => theme.spacing(2)};
  z-index: ${({ theme }) => theme.zIndex.drawer + 1};
  min-width: 0;
  padding: ${({ theme }) => theme.spacing(0.25, 1)};
  border-radius: 999px;
  font-size: 11px;
  line-height: 1;
`;

const BetaFeaturesButton = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const hasActiveBetaFeatures = useActiveBetaFeatures();

  if (!hasActiveBetaFeatures) {
    return null;
  }

  return (
    <>
      <Launcher
        size='small'
        variant='contained'
        onClick={() => setDialogOpen(true)}
      >
        BETA
      </Launcher>
      <BetaFeaturesDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};

export default BetaFeaturesButton;
